module.exports = __webpack_public_path__ + "img/sr.bd4753be.svg";